module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAALxJREFUSEvt1jEKwjAUBuD/jQY62dkT9Ag9QopCjlCSYzh5BifBOXN7iI45iEKhEMcnDhW3Rho6vax55CcfIfzknDsw85mIjgBK5F8vZr4T0YWstbeiKNqqqlCW+bPGcUQIAdM0Xck5F+u63hljoJTKfq8YI7z3GIbh8QljrTWapskeNB/YdR36voeErSIWxlV88hqz8AmjMCYJyHeVxLQ0JIxLQkn7v4xbtavn5r1xbsQnAPskl/+Gvo34DRx08HoiIbB/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_checkbox01.png
// module id = OpYz
// module chunks = 5